import React, { useEffect, useRef } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { message } from "antd";

interface QRScannerProps {
  onScanSuccess: (
    decodedText: string,
    location?: GeolocationCoordinates
  ) => void;
  requireLocation?: boolean;
}

const QRScanner: React.FC<QRScannerProps> = ({
  onScanSuccess,
  requireLocation
}) => {
  const scannerRef = useRef<Html5QrcodeScanner | null>(null);

  useEffect(() => {
    // Initialize the QR scanner
    const qrScanner = new Html5QrcodeScanner(
      "qr-reader",
      { fps: 10, qrbox: { width: 250, height: 250 } },
      false
    );

    // Handle successful scan
    const handleScan = async (decodedText: string) => {
      if (requireLocation) {
        try {
          const position = await getCurrentPosition();
          onScanSuccess(decodedText, position.coords);
        } catch (error) {
          message.error("Location access is required for attendance");
        }
      } else {
        onScanSuccess(decodedText);
      }
    };

    // Render the QR scanner
    qrScanner.render(handleScan, (error) => {
      console.error(error);
    });

    // Store the scanner instance in ref
    scannerRef.current = qrScanner;

    // Cleanup function to clear scanner on unmount
    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [onScanSuccess, requireLocation]);

  // Geolocation helper function
  const getCurrentPosition = (): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported"));
        return;
      }
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  return <div id="qr-reader" className="w-full max-w-md mx-auto" />;
};

export default QRScanner;
